import { Grid } from '@material-ui/core';
import React from 'react';
import { IButton } from 'src/common/interfaces/IButton';
import { styles } from './force-exchange-component-styles';
import BaseButton from '../../common/components/base-button';

export interface ForcedExchangeModalButtonsProps {
  closeButton: IButton;
  selectButton: IButton;
  overrideButton: IButton;
  saleModeButton: IButton;
}

export const getForcedExchangeModalButtons = (props: ForcedExchangeModalButtonsProps) => {
  return <ForcedExchangeModalButtons {...props} />;
};

export const ForcedExchangeModalButtons = (props: ForcedExchangeModalButtonsProps) => {
  const classes = styles();
  const { closeButton, selectButton, overrideButton, saleModeButton } = props;
  return (
    <Grid className={classes.container} container justifyContent='space-between'>
      <Grid item container alignItems='center' justifyContent='flex-start' xs={2}>
        <BaseButton
          className={classes.closeButton}
          fullWidth
          centerRipple={true}
          data-testid='force-exchange-model-close-button'
          variant='contained'
          onClick={() => closeButton.onClick()}
        >
          {closeButton.label}
        </BaseButton>
      </Grid>
      <Grid item container alignItems='center' justifyContent='flex-end' xs={10}>
        <BaseButton
          className={classes.rightButton}
          centerRipple={true}
          data-testid='force-exchange-model-select-button'
          variant='contained'
          color='primary'
          onClick={() => selectButton.onClick()}
          disabled={selectButton.disabled}
        >
          {selectButton.label}
        </BaseButton>
        <BaseButton
          className={classes.rightButton}
          centerRipple={true}
          data-testid='force-exchange-model-override-button'
          variant='contained'
          color='primary'
          onClick={() => overrideButton.onClick()}
          disabled={overrideButton.disabled}
        >
          {overrideButton.label}
        </BaseButton>
        <BaseButton
          className={classes.rightButton}
          centerRipple={true}
          data-testid='force-exchange-model-sale-mode-button'
          variant='contained'
          color='primary'
          onClick={() => saleModeButton.onClick()}
          disabled={saleModeButton.disabled}
        >
          {saleModeButton.label}
        </BaseButton>
      </Grid>
    </Grid>
  );
};
